import { useQuery } from '@tanstack/react-query';
import { executeAppAction, BASE_URL } from '@/services/DataService';
import { toastError } from '@strivelabs/ui-core';
import type { DataTableClientContent } from '@/types/ui-blocks';
import type { TimeTravelMetricsParams } from './useTimeTravelMetrics';

export function useKeywordTimeTravelMetrics(
  params: TimeTravelMetricsParams | null,
  enabled: boolean
) {
  return useQuery<DataTableClientContent | null>({
    queryKey: [
      'keywordTimeTravelMetrics',
      params?.google_ads_dataset_id,
      params?.campaign_id,
      params?.current_period_start_date,
      params?.current_period_end_date,
      params?.baseline_period_start_date,
      params?.baseline_period_end_date,
    ],
    queryFn: async () => {
      if (!params) return null;

      try {
        const result = await executeAppAction(
          BASE_URL,
          'google_ads_campaign_analyzer_insight',
          'fetch_keyword_time_travel_metrics',
          [],
          [params]
        );

        const block = result?.items?.[0]?.data?.keyword_time_travel_metrics;

        if (block?.type === 'data_table_client' && block.content) {
          return block.content as DataTableClientContent;
        }

        return null;
      } catch {
        toastError('Failed to fetch custom keyword metrics. Using original data.');
        return null;
      }
    },
    enabled: enabled && !!params,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
